/**
 * 教师端权限：优先 auth/info，空则静态兜底
 * 不请求 auth/routers
 */
import { teacherAuthInfo } from "@/api/teacher/auth";
import {
  getUserInfo,
  getUserRoleKeys,
  normalizeTeacherAuthInfo
} from "@/utils/userInfo";
import { TEACHER_STATIC_PERMISSIONS } from "@/config/teacherStaticPermissions";

const PERMISSIONS_KEY = "userPermissions";

export const ALL_PERMISSION = "*:*:*";

function normalizePerm(value) {
  return value == null ? "" : String(value).trim();
}

export function setUserPermissions(permissions) {
  const list = Array.isArray(permissions)
    ? permissions.map(normalizePerm).filter(Boolean)
    : [];
  sessionStorage.setItem(PERMISSIONS_KEY, JSON.stringify(list));
}

export function getUserPermissions() {
  try {
    const raw = sessionStorage.getItem(PERMISSIONS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
}

export function clearUserPermissions() {
  sessionStorage.removeItem(PERMISSIONS_KEY);
}

export function isSuperAdmin() {
  const roleKeys = getUserRoleKeys();
  return roleKeys.includes("admin");
}

export function hasPermission(value) {
  if (!value) return false;
  const permissions = getUserPermissions();
  if (isSuperAdmin() || permissions.includes(ALL_PERMISSION)) {
    return true;
  }
  const required = (Array.isArray(value) ? value : [value])
    .map(normalizePerm)
    .filter(Boolean);
  if (!required.length) return false;
  return required.some(perm => permissions.includes(perm));
}

export async function loadUserPermissions(vueInstance) {
  try {
    let permissions = [];
    const info = getUserInfo() || {};
    permissions = Array.isArray(info.permissions) ? info.permissions : [];
    if (!permissions.length) {
      try {
        const result = await teacherAuthInfo();
        const data = normalizeTeacherAuthInfo(
          (result && result.data) || result || {}
        );
        permissions = Array.isArray(data.permissions) ? data.permissions : [];
      } catch (e) {
        permissions = [];
      }
    }
    if (!permissions.length) {
      permissions = Array.isArray(TEACHER_STATIC_PERMISSIONS)
        ? TEACHER_STATIC_PERMISSIONS
        : [];
    }
    setUserPermissions(permissions);
    if (vueInstance && vueInstance.$root && vueInstance.$root.Bus) {
      vueInstance.$root.Bus.$emit("permissions-updated");
    }
    return permissions;
  } catch (e) {
    setUserPermissions(TEACHER_STATIC_PERMISSIONS || []);
    if (vueInstance && vueInstance.$root && vueInstance.$root.Bus) {
      vueInstance.$root.Bus.$emit("permissions-updated");
    }
    return TEACHER_STATIC_PERMISSIONS || [];
  }
}



// WEBPACK FOOTER //
// ./src/utils/permission.js